// src/pages/administrativo/EmpresaSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useEmpresa } from '../../contexts/administrativo/EmpresaContext';  // Contexto de Empresa
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const EmpresaSearch = ({ show, onHide, onSelectEmpresa }) => {
    const { empresas } = useEmpresa(); // Contexto de empresas
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id'); // 'id' ou 'nome'
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' ou 'desc'
     // Quantidade de itens por página

    const inputRef = useRef(null); // Referência para o input

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) {
                inputRef.current.focus(); // Aplica o foco no input quando o modal abrir
            }
        }
    }, [show]);

    if (!show) return null;

    // Filtra as empresas pelo nome
    const filteredEmpresas = empresas.filter(empresa =>
        empresa.nome.toLowerCase().includes(filter.toLowerCase())
    );

    // Ordena as empresas de acordo com o campo e direção selecionados
    const sortedEmpresas = filteredEmpresas.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'nome') {
            const nameA = a.nome.toLowerCase();
            const nameB = b.nome.toLowerCase();
            if (nameA < nameB) return sortDirection === 'asc' ? -1 : 1;
            if (nameA > nameB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0; // Retorno padrão
    });

    // Divide as empresas em páginas

    // Número total de páginas

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (empresa) => {
        onSelectEmpresa(empresa);
        onHide();
    };

    return (
        <ModalContainer show={show} largura="600px" variant="busca" onHide={onHide}>

            <ModalHeader title="Buscar Empresa" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por nome..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedEmpresas} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight:'bold', background: 'none', border: 'none' }} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '70%' }} aria-sort={sortField === 'nome' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('nome')} style={{ fontWeight:'bold', background: 'none', border: 'none' }} type="button">
                                    Nome
                                    {sortField === 'nome' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(empresa => (
                            <tr key={empresa.id} onDoubleClick={() => handleDoubleClick(empresa)}>
                                <td className="text-end align-middle">{empresa.id}</td>
                                <td className="align-middle">{empresa.nome}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectEmpresa(empresa)} style={{ padding: '2px 6px' }} label={empresa.nome} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>

        </ModalContainer>
    );
};

export default EmpresaSearch;
